import React, { useEffect, useState } from 'react';
import {
  Box,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField
} from '@mui/material';
import MUITypography from '../../Components/MUITypography';
import { VM_Colors, align_row } from '../../Styles/VMStyles';
import MuiTypographyMandatory from '../../Components/Custom/MuiTypographyMandatory';
import { toTitleCase } from '../../Util/UtilHelper';

const eventCategories = {
  "Traditional Events": [
    "Engagement","Haldi Event","Mehendi Event","Sangeet Event", "Wedding", "Reception",  "Groom Ceremony", "Bride Ceremony" 
  ],
  "Regular Events": [
    "Birthday Event", "Saree Ceremony", "Dhoti Ceremony","Wedding Anniversary","Death Anniversary","Retirement Ceremony", "Baby Shower","Cradle Ceremony"
],
  "Corporate Events": [
    "Product Launch", "Conference Meeting", "Meet-Up’s", "Exhibition", "Expo", "Audio Launch’s", "Team Outing"
  ],
  "Hangouts (Farmhouse/Villas)": [
    "Friends", "Family", "Employees"
  ]
};

function EventTypeSelection({ event_type, event_name, handleChange, handleChangeMultiple }) {
  const [subTypes, setSubTypes] = useState([]);
  const [customEventName, setCustomEventName] = useState('');

  const isCustomCategory = event_type === 'Others';
  const isCustomEventName = event_name === 'Others';

  useEffect(() => {
    if (event_type === 'Others') {
      setCustomEventName(event_name || '');
    } else {
      setCustomEventName('');
    }
    if (event_type && eventCategories[event_type]) {
      setSubTypes(eventCategories[event_type]);
    } else {
      setSubTypes([]);
    }
  }, [event_type, event_name]);

  const handleCategoryChange = (e) => {
    const newType = e.target.value;

    if (handleChangeMultiple) {
      handleChangeMultiple({
        event_type: newType,
        event_name: "" // reset event_name when category changes
      });
    } else {
      handleChange("event_type", newType);
      handleChange("event_name", "");
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Category Radio Group */}
      <Box sx={{ overflowX: "auto", whiteSpace: "nowrap", pb: 1 }}>
        <RadioGroup
          row
          value={event_type}
          onChange={handleCategoryChange}
        >
          {Object.keys(eventCategories).map((cat) => (
            <FormControlLabel
              key={cat}
              value={cat}
              control={<Radio />}
              label={cat}
              sx={{ mr: 2, whiteSpace: "nowrap" }}
            />
          ))}
          <FormControlLabel
            value="Others"
            control={<Radio />}
            label="Others"
            sx={{ mr: 2, whiteSpace: "nowrap" }}
          />
        </RadioGroup>
      </Box>

      {/* Dropdown or Input for Event Name */}
      {!isCustomCategory && (
        <Box sx={align_row}>
          <Stack width="100%">
            <MuiTypographyMandatory label="Select Event Name" required />
            <Select
              fullWidth
              value={event_name || ""}
              onChange={(e) => handleChange("event_name", e.target.value)}
              sx={{ backgroundColor: VM_Colors.white }}
              displayEmpty
            >
              <MenuItem value="" disabled>
                -- Select --
              </MenuItem>
              {subTypes.map((sub) => (
                <MenuItem key={sub} value={sub}>
                  {sub}
                </MenuItem>
              ))}
              {/* <MenuItem value="Others">Others</MenuItem> */}
            </Select>
          </Stack>
        </Box>
      )}

      {/* If category or name is Others, allow free text entry */}
      {(isCustomCategory || isCustomEventName) && (
        <Box sx={align_row}>
          <Stack width="100%">
            <MUITypography variant="body1" gutterBottom>
              Enter Custom Event Name
            </MUITypography>
            <TextField
              fullWidth
              value={customEventName}
              onChange={(e) => {
                setCustomEventName(e.target.value);
                handleChange("event_name", e.target.value);
              }}
              placeholder={toTitleCase("Enter custom event name")}
            />
          </Stack>
        </Box>
      )}
    </Box>
  );
}

export default EventTypeSelection;
